import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../.';
import { populateChildren } from './toolbox';

const QEnvsQuery = graphql`
  query QEnvsQuery {
    envs {
      envs
    }
  }
`;

const QEnvs = ({
  children,
  childDataProp,
  args
}) => (
  <Query
    query={QEnvsQuery}
    args={args}
    // store-or-network: envs are stable server-side data.
    // This avoids a redundant network call on every navigation/login.
    fetchPolicy="store-or-network"
  >
    {populateChildren('envs')(children, childDataProp)}
  </Query>
);

export default QEnvs;
